import type { FC } from "react";
import styled from "styled-components";
import { useSidebarState } from "../../../hooks/state";
import { mediaQueryMaxMedium } from "../../../mediaQuery";
import { zIndex } from "../../constants";
import { SIDEBAR, TRANSITION_SPEED } from "./constants";

type SidebarContainerProps = {
  show: boolean;
  isCollapsed: boolean;
};

// This container is mainly used to take up space on the page, displacing the
// content. It should have no visible styles outside of taking up space.
// It manages the space taken up on the page depending on the collapse state.
const SidebarContainerStyles = styled.aside<SidebarContainerProps>`
  grid-area: aside;
  position: fixed;
  z-index: ${zIndex.overContentMenu}; /* Would prefer to go without but MFEs do stuff. */
  width: ${({ isCollapsed }) =>
    isCollapsed ? SIDEBAR.collapsedWidth : SIDEBAR.width}px;
  transition: width ${TRANSITION_SPEED}s;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  ${mediaQueryMaxMedium} {
    display: ${({ show }) => (show ? "block" : "none")};
  }
`;

export const SidebarContainer: FC<{ show?: boolean }> = ({
  children,
  show = true,
}) => {
  const state = useSidebarState();

  return (
    <SidebarContainerStyles
      // Using onPointerOver instead of onPointerEnter because it needs to
      // bubble and be cancelable for the expand-button to not trigger hover
      // action.
      // https://w3c.github.io/pointerevents/#dfn-attributes-and-default-actions
      show={show}
      isCollapsed={state.isCollapsed}
    >
      {children}
    </SidebarContainerStyles>
  );
};
